module.exports = __webpack_public_path__ + "img/3.a1b9b57b.jpg";